import React, { useContext } from "react";
import { withStyles } from "@material-ui/core/styles";
import { Menu, MenuItem, ListItemIcon, ListItemText } from "@material-ui/core";
import {
  SupervisedUserCircle,
  AccountCircle,
  Brightness4,
  Brightness7,
  RotateLeft,
  ExitToApp,
} from "@material-ui/icons";
import { ThemeContext } from "../../../../Context/Theme";
import { RouteContext } from "../../../../Context/RouteContext";
import Auth from "@aws-amplify/auth";
import { AuthContext } from "../../../../Context/Auth";
import { useHistory } from "react-router";

const StyledMenu = withStyles({
  paper: {
    border: "1px solid #d3d4d5",
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "center",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "center",
    }}
    {...props}
  />
));

const StyledMenuItem = withStyles((theme) => ({
  root: {
    "&:focus": {
      backgroundColor: theme.palette.common.white,
      "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
        color: theme.palette.common.black,
      },
    },
  },
}))(MenuItem);

const MobileMenu = ({ anchorEl, handleClose }) => {
  const history = useHistory();
  const { dark, toggle } = useContext(ThemeContext);
  const { resetRoute } = useContext(RouteContext);
  const { logout } = useContext(AuthContext);

  function signOut() {
    Auth.signOut()
      .then((data) => {
        logout();
        localStorage.clear();
        resetRoute();
      })
      .catch((err) => {});
  }

  return (
    <div>
      <StyledMenu
        id="customized-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        data-testid={`userActionButton`}
      >
        <StyledMenuItem data-testid={`darkModeButton`} onClick={toggle}>
          <ListItemIcon>
            {!dark ? <Brightness4 /> : <Brightness7 />}
          </ListItemIcon>
          <ListItemText
            aria-label="dark_mode_status"
            primary={dark ? "Toggle light mode" : "Toggle dark mode"}
          />
        </StyledMenuItem>
        <StyledMenuItem>
          <ListItemIcon>
            <AccountCircle fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Account" />
        </StyledMenuItem>
        <StyledMenuItem
          data-testid={`resetPasswordButton`}
          onClick={() => history.push("/reset-password")}
        >
          <ListItemIcon>
            <RotateLeft fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Reset Password" />
        </StyledMenuItem>
        <StyledMenuItem data-testid={`logoutButton`} onClick={signOut}>
          <ListItemIcon>
            <ExitToApp fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Logout" />
        </StyledMenuItem>
      </StyledMenu>
    </div>
  );
};

export default MobileMenu;
